/**
 * PHARMAKON — Fournisseur ERP · Notification API service (Module 00)
 *
 * Per-staff supplier notification feed (Implementation_Plan §6.3, Appendix C.7).
 * Mounted at /fournisseur-portail/notifications. The client interceptor returns
 * the response body; the feed envelope is { data:[...], meta:{ total, unread } }.
 *
 * Legacy alias note: the monolith used /fournisseur-portail/notifs. The plan
 * keeps those as matrix-gated aliases during migration; this service targets the
 * new canonical paths.
 */
import api from "../../services/api.client.js";

// Canonical backend paths (fournisseurStaff.routes.js, mounted under
// /fournisseur-portail): the feed + batch mark-read live under /notifications,
// the per-staff preferences under the sibling /notification-prefs.
const BASE = "/fournisseur-portail/notifications";
const PREFS = "/fournisseur-portail/notification-prefs";

export const notificationService = {
  /** Feed (org-broadcast ∪ self). params: { page, limit, unread_only }. */
  list: (params = {}) => api.get(BASE, { params }),

  /**
   * Unread badge count. There is no dedicated /count route — the feed envelope
   * already carries a per-staff top-level `unread`, so we fetch a single row to
   * keep the poll light and read the count off the envelope.
   */
  count: () => api.get(BASE, { params: { limit: 1 } }),

  /** Mark one notification read (batch endpoint with a single id). */
  markRead: (id) => api.post(`${BASE}/mark-read`, { ids: [id] }),

  /** Mark all visible notifications read (empty ids = all of this staff's feed). */
  markAllRead: () => api.post(`${BASE}/mark-read`, { ids: [] }),

  /** Per-staff notification preferences. */
  getPreferences: () => api.get(PREFS),
  updatePreferences: (body) => api.put(PREFS, body),
};

export default notificationService;
